import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import Span from 'src/components/atomic/atom/Span'
import Svg from 'src/components/atomic/atom/Svg'
import useMediaQueryHook from 'src/hooks/useMediaQuery.hook'
import { useScriptHook } from 'src/hooks/useScript.hook'
import { FacebookUserResponseType, LoginProps } from 'src/views/Account/Login'
import facebook_logo from 'src/assets/imgs/logo/facebook.png'
import Image from 'src/components/atomic/atom/Image'
import { SocialLoginBtn } from 'src/components/atomic/organisms/views/Login/GoogleLoginForm'
import { useAppDispatch } from 'src/hooks/redux/useAppDispatch'
import { setModalItems } from 'src/store/Reducer/common/modalSlice'

type FacebookLoginResponse = {
  status: 'connected' | 'not_authorized' | 'unknown'
  authResponse?: FacebookAuthResponse
}

type FacebookAuthResponse = {
  userID: string
  accessToken: string
  expiresIn: number
  signedRequest: string
  graphDomain?: string
  data_access_expiration_time?: number
  grantedScopes?: string
}

const APP_ID = process.env.REACT_APP_FACEBOOK_APP_ID

// 페이스북 로그인 컴포넌트
const FacebookLoginForm = (props: { data: LoginProps }) => {
  const { FaceBookLoginSuccessHandler } = props.data
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const { setMediaStyle } = useMediaQueryHook()
  const status = useScriptHook('https://connect.facebook.net/en_US/sdk.js', {
    removeOnUnmount: false,
  })

  useEffect(() => {
    if (typeof window.FB !== 'undefined') {
      window.FB.init({
        appId: `${APP_ID}`,
        cookie: true,
        xfbml: false,
        version: 'v19.0',
      })
    }
  }, [status])

  const FacebookLoginBtnHandler = () => {
    if (typeof window.FB !== 'undefined') {
      window.FB.login(
        (response: FacebookLoginResponse) => {
          if (response.status === 'connected') {
            const grantedPermissions = response.authResponse?.grantedScopes

            if (!grantedPermissions?.includes('email')) {
              dispatch(
                setModalItems({
                  type: 'alert',
                  text: t('LOGIN.ERROR_EMAIL_PERMISSION', {
                    defaultValue:
                      'To become a member, you must permit MFinder to access your profile(Email address).',
                  }) as string,
                }),
              )
              return
            }
            window.FB.api('/me', { fields: 'email' }, (userData: FacebookUserResponseType) => {
              FaceBookLoginSuccessHandler(userData)
            })
          }
        },
        {
          scope: 'public_profile,email',
          return_scopes: true,
          auth_type: 'rerequest',
        },
      )
    }
  }

  return (
    <SocialLoginBtn
      width={setMediaStyle('396px', '100%', '100%')}
      height={setMediaStyle('52px', '49px', '52px')}
      onClick={FacebookLoginBtnHandler}
    >
      <Image $ImgSrc={facebook_logo} width={'20px'} height={'20px'} />
      <Span option={'small_bold'} display={'flex'} $text_align={'left'}>
        {t('BUTTON.SIGN_IN_FACEBOOK', { defaultValue: 'Sign in with Facebook' })}
      </Span>
      <Svg name={'arrow'} />
    </SocialLoginBtn>
  )
}

export default FacebookLoginForm
